import { EncodingTool } from "../../../components/developerTools/EncodingTool";
import { ToolLayout } from "../../../components/developerTools/ToolLayout";



/** Displays the local UTF-8 hexadecimal encoder and decoder. */
export const HexTool = () => (
	<ToolLayout title="Hex Encoder & Decoder" description="Convert UTF-8 text to hexadecimal bytes and back." local>
		<EncodingTool format="hex" />
	</ToolLayout>
);
